import { defineComponent as _defineComponent } from 'vue'
export type PointerPosition = 'top' | 'right' | 'bottom' | 'left';

/**
 * `PanelPointer` component properties.
 */
export interface Props {
  side?: PointerPosition;
  pos?: number;
  unit?: string;
}


import { computed } from 'vue';
import type { StyleValue } from 'vue/types/jsx';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    PanelPointer: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'PanelPointer' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    side: { default: 'right' },
    pos: { default: 10 },
    unit: { default: 'px' }
  },
  setup(__props: any) {

const props = __props as { side: PointerPosition, pos: number, unit: string };

/** ... */


/** ... */
const info = computed(() => {
  const styleProp =
    props.side === 'top' || props.side === 'bottom' ? 'left' : 'top';

  const className = `menu-pointer-${props.side}`;

  const style: StyleValue = { [styleProp]: props.pos.toString() + props.unit };

  return { className, style };
});

return { __sfc: true,props, info }
}

})